import { getEternalEndDate } from '../utils/getEternalEndDate';
import { redirectToCoursePage } from '../utils/redirectToCoursePage';

export default {
  data() {
    return {
      timer: {
        // таймер
        duration: null,
        interval: null,
      },
    };
  },
  mounted() {
    this.setTimerInterval();
  },
  beforeDestroy() {
    clearInterval(this.timer.interval);
  },
  methods: {
    setTimerInterval() {
      const dayjs = this.$dayjs;

      const end = this.$store.state.sale.sale.endDate;
      const endDate = dayjs(end);

      const eternal = this.$store.state.sale.sale.modes.eternalCounter;
      const timerMode = this.$store.state.sale.sale.unlimitedTimerMode;

      this.timer.interval = setInterval(() => {
        const curDate = dayjs();

        // Дата окончания заполнена
        if (end) {
          // Время истекло
          if (endDate < curDate) {
            // Редирект на страницу курсов. Распродажа окончена
            clearInterval(this.timer.interval);
            window.location = redirectToCoursePage(this.$store);
            return;
          }

          // Таймер не бесконечный - дата окончания на endDate
          if (!eternal) {
            const diff = dayjs(endDate).diff(curDate);
            this.timer.duration = dayjs.duration(diff);
            return;
          }
        }

        // Таймер бесконечный - дата окончания на eternalEndDate
        // Если таймер бесконечный - не важно, заполнен ли endDate.
        if (eternal) {
          const eternalDateGetter = getEternalEndDate.bind(this);
          const eternalDateRaw = eternalDateGetter(timerMode);
          const eternalDate = dayjs(eternalDateRaw);
          const diff = dayjs(eternalDate).diff(curDate);
          this.timer.duration = dayjs.duration(diff);
          return;
        }

        // Не может быть кейса, где !eternal и !endDate
        if (!eternal && !end) {
          console.error('"endDate" AND "eternal" not setted');
        }
      }, 1000);
    },
  },
};
